export interface SquareValue {
  first: string;
  second: string;
  third: string;
  fourth: string;

  linked: string;
  isLinked: boolean;
}

export const parseValue = (value: string | undefined): SquareValue => {
  if (!value) {
    value = "true|0px|0px|0px|0px|0px";
  } else if (value.match(/^-?\d+[^|]*$/)) {
    value = `true|${value}|${value}|${value}|${value}|${value}`;
  }

  const parts = value.split("|");
  return {
    isLinked: parts[0] === "true",
    linked: parts[1],
    first: parts[2],
    second: parts[3],
    third: parts[4],
    fourth: parts[5]
  };
};

export const serializeValue = (value: SquareValue): string =>
  value.isLinked &&
  value.linked === value.first &&
  value.first === value.second &&
  value.second === value.third &&
  value.third === value.fourth
    ? value.linked
    : `${value.isLinked}|${value.linked}|${value.first}|${value.second}|${value.third}|${value.fourth}`;
